import styled from 'styled-components';

const LayoutStyled = styled.div`
  min-height: 100vh;

  .ant-sider {
    position: fixed;
    height: 100vh;
    z-index: 3;

    + .site-layout {
      margin-left: 200px;
    }

    &.ant-layout-sider-below {
      //this css show up on small screen //when the sider collapsible
      + .site-layout {
        margin-left: 0;
      }
    }
    .ant-layout-sider-children {
      overflow: hidden;
    }
  }

  .menu-fixed-bottom {
    position: absolute;
    width: 100%;
    bottom: 0px;
  }
  .logo {
    max-width: 100%;
    width: 95px;
    margin: 10px 0;
    margin-left: 15px;
  }

  .site-header {
    background: white;
    text-align: center;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: 1px 1px 9px rgba(0, 0, 0, 0.3);
    z-index: 1;

    .store-name {
      font-size: 16px;
      font-weight: bold;
    }

    .store-info {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .info-row {
        margin: 0 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .store-logo {
    padding: 15px;
    width: 200px;
    max-height: 130px;
    object-fit: contain;
  }

  .footer-text {
    text-align: center;
    color: #333;
    text-shadow: 1px 1px 2px rgba(77, 89, 98, 0.2);
    background: #d7dadc;
    padding-top: 5px;
    line-height: 40px;
  }
`;

export default LayoutStyled;
